// extracted by mini-css-extract-plugin
export default {"tabContentBottom":"TabContentServices_tabContentBottom__b15nu","tabContentTitle":"TabContentServices_tabContentTitle__82hxZ"};